
import React from 'react';
import { Bookmark } from 'lucide-react';

const SavedArticlesContent: React.FC = () => {
  return (
    <div className="text-center py-10">
      <Bookmark className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
      <p className="text-xl font-medium mb-2">No saved articles yet</p>
      <p className="text-muted-foreground mb-4">
        Articles you save will appear here for easy access.
      </p>
    </div>
  );
};

export default SavedArticlesContent;
